import { useSettingData } from "@/data/use-settings-data";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { Navigate } from "@tanstack/react-router";

export default function GroupAdminRedirectPage() {
  const groupUuid = useGroupUuid();
  const groupSlug = useGroupSlug();
  const { value: sharedGroupUuid, isLoading: isLoadingSettings } =
    useSettingData(groupUuid, "SHARED_WORKSPACE_UUID");

  if (isLoadingSettings) {
    return <></>;
  }

  if (sharedGroupUuid === groupUuid) {
    return (
      <Navigate
        to="/w/$groupSlug/settings/shared-knowledge"
        params={{ groupSlug }}
        replace
      />
    );
  }

  return (
    <Navigate
      to="/w/$groupSlug/settings/knowledge"
      params={{ groupSlug }}
      replace
    />
  );
}
